export const downloadExcel = (base64: string, filename: string) => {
  const link = document.createElement("a");
  link.href = `data:@file/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64}`;
  link.download = filename;
  link.click();
};
